import React, { Component } from 'react';
import logo from "../../../public/img/LogoWeb.png";

class Dashboard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="animated fadeIn dashboard">
        <div className="app flex-row bgimg">
          <div className="justify-content-center row m-auto">
            <div className="col col-md-7">
            <img className="col-md-12 login-group" src={logo}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Dashboard;




// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js